// import { FeatureConfig } from '@core/AbTesting/AbTesting.types'
import { CEFRLevels } from '../Book'
import { ExerciseType } from '../Exercise'
// import { OnboardingEnglishLevel } from '../Onboarding/Onboarding.types'
// import { Branding } from '../BrandingLoginOptions/BrandingLoginOptions.types'

export enum AchievementName {
  FIRST_SENTENCE = 'First Sentence Completed!',
  // PLACEMENT_TEST_COMPLETED = 'Placement Test Completed!',
  PAGEMASTER = 'Pagemaster',
  POWER_BUILDER = 'Power Builder',
  SPEEDMASTER = 'Speedmaster',
  WORD_WIZARD = 'Word Wizard',
  PRONUNCIATION_EXPERT = 'Pronunciation Expert',
  GOALS = '#Goals',
  GOALS_200 = '#Goals 200%',
  GOALS_300 = '#Goals 300%',
  GOALS_400 = '#Goals 400%',
  NEW_RECORD = 'New Record',
  DAILY_GOAL = 'Daily Goal',
  // STUDY_SET = 'Study Set',
  PERFECT_WEEK = 'Perfect Week',
  PERFECT_MONTH = 'Perfect Month',
  VIP = 'VIP'
}

export enum ForgotPasswordResult {
  SentToMail = 'SENT_TO_MAIL',
  SentToParents = 'SENT_TO_PARENTS',
  ContactTeacher = 'CONTACT_TEACHER'
}

export enum GoalNames {
  BooksFinished = 'BooksFinished',
  ExercisesFinished = 'ExercisesFinished',
  TimeSpent = 'TimeSpent'
}

export enum AccountTier {
  Free = 'Free',
  Premium = 'Premium',
  Pro = 'Pro'
}

export interface UpdateLists {
  blockList: string[]
  updateList: string[]
}

export enum VerificationStatus {
  NOT_VERIFIED = 'NOT_VERIFIED',
  VERIFIED = 'VERIFIED',
  CHANGED = 'CHANGED',
  NO_EMAIL_USER = 'NO_EMAIL_USER'
}

export enum EnglishDialect {
  EnUS = 'en-us',
  EnGB = 'en-gb'
}

export enum SubscriptionProductId {
  // CURRENT:
  IOS_1_MONTH_PREMIUM_1_WEEK_TRIAL = 'astrid_p_1w0_1m',
  IOS_6_MONTH_PREMIUM_1_WEEK_TRIAL = 'astrid_p_1w0_6m',
  IOS_12_MONTH_PREMIUM_1_WEEK_TRIAL = 'astrid_p_1w0_12m',

  ANDROID_1_MONTH_PREMIUM_1_WEEK_TRIAL = 'astrid_p_1w0_1m',
  ANDROID_6_MONTH_PREMIUM_1_WEEK_TRIAL = 'astrid_p_1w0_6m',
  ANDROID_12_MONTH_PREMIUM_1_WEEK_TRIAL = 'astrid_p_1w0_12m',

  // OLD:
  IOS_1_MONTH = 'astrid_1m',
  IOS_3_MONTHS = 'astrid_3m',
  IOS_6_MONTHS = 'astrid_6m',

  IOS_1_MONTH_75_OFF = 'astrid_1m_75off',
  IOS_3_MONTHS_75_OFF = 'astrid_3m_75off',
  IOS_6_MONTHS_75_OFF = 'astrid_6m_75off',

  IOS_1_MONTH_WITH_1_WEEK_TRIAL = 'astrid_1m_1w0',
  IOS_3_MONTHS_WITH_1_WEEK_TRIAL = 'astrid_3m_1w0',
  IOS_6_MONTHS_WITH_1_WEEK_TRIAL = 'astrid_6m_1w0',

  IOS_1_MONTH_WITH_1_WEEK_TRIAL_75_OFF = 'astrid_1m_1w0_75off',
  IOS_3_MONTHS_WITH_1_WEEK_TRIAL_75_OFF = 'astrid_3m_1w0_75off',
  IOS_6_MONTHS_WITH_1_WEEK_TRIAL_75_OFF = 'astrid_6m_1w0_75off',

  ANDROID_1_MONTH = 'astrid_1month',
  ANDROID_3_MONTHS = 'astrid_3months',
  ANDROID_6_MONTHS = 'astrid_6months',

  ANDROID_1_MONTH_75_OFF = 'astrid_1m_75off',
  ANDROID_3_MONTHS_75_OFF = 'astrid_3m_75off',
  ANDROID_6_MONTHS_75_OFF = 'astrid_6m_75off',

  ANDROID_1_MONTH_WITH_1_WEEK_TRIAL = 'astrid_1m_1w0',
  ANDROID_3_MONTHS_WITH_1_WEEK_TRIAL = 'astrid_3m_1w0',
  ANDROID_6_MONTHS_WITH_1_WEEK_TRIAL = 'astrid_6m_1w0',

  ANDROID_1_MONTH_WITH_1_WEEK_TRIAL_75_OFF = 'astrid_1m_1w0_75off',
  ANDROID_3_MONTHS_WITH_1_WEEK_TRIAL_75_OFF = 'astrid_3m_1w0_75off',
  ANDROID_6_MONTHS_WITH_1_WEEK_TRIAL_75_OFF = 'astrid_6m_1w0_75off'
}

export type UserProfile = {
  firstName: string
  lastName: string
  birthYear: number
  globalScore: number
  isPlacementTestCompleted: boolean
  shouldDisplayRatePopup: boolean
  introStoryCompleted: boolean
  level?: CEFRLevels
  school: {
    name: string
    address?: string
  }
  goals: {
    timeSpent: number
    booksCompleted: number
    exerciseCompleted: number
  }
  learningGoals: {
    fluency: number
    comprehension: number
    timeSpent: number
    booksCompleted: number
    exercisesCompleted: number
  }
  country: string
  englishDialect: EnglishDialect
  grade: string
  parent?: {
    name1?: string
    email1?: string
    name2?: string
    email2: string
  }
  avatar?: string
}

export type Reward = {
  name: AchievementName
  score?: number
  goal?: GoalNames
  exerciseType?: ExerciseType
}

export interface UserNotificationsSettings {
  studyReminder: boolean
  progressUpdates: boolean
  astridNews: boolean
}

export interface User {
  _id: string
  username: string
  hasPassword?: boolean
  email?: string
  verificationStatus: VerificationStatus
  onboardingCompleted: boolean
  accessTutoringService?: boolean
  isCreator?: boolean
  isOldUser: boolean
  showPaymentIOs: boolean
  showPaymentAndroid: boolean
  profile: UserProfile
  rewards: Reward[]
  showPayment: boolean
  specialOfferClaimed: boolean
  soundEffectsEnabled: boolean
  npsPopupCompleted: boolean
  freeTrialEndsAt?: string
  ptTrialInvitePopupCompleted?: boolean
  phoneNumber?: string
  paywallExperimentVariant: string | undefined
  subscription?: {
    productId: string | SubscriptionProductId
    startDate?: number
    expirationDate: number
    autoRenew: boolean
    freeTrial?: boolean
    price?: number
    priceCurrency?: string
  }
  // featureConfig: FeatureConfig
  notificationSettings: UserNotificationsSettings
  hasSubscription: boolean
  tier?: AccountTier
  // branding?: Branding
  unableToChangePassword: boolean
  allowGiveFeedback: boolean
  allowSubscription: boolean
  accountDeletionInstructions?: string
  showGeseLevel?: boolean
}

export interface ProfileUpdate {
  firstName?: string
  lastName?: string
  globalScore?: number
  shouldDisplayRatePopup?: boolean
  introStoryCompleted?: boolean
  parent?: {
    name1?: string | null
    name2?: string | null
    email1?: string | null
    email2?: string | null
  }
  avatar?: null
  isPlacementTestCompleted?: boolean
}

export enum SocialAuthMethod {
  GOOGLE = 'google',
  APPLE = 'apple',
  FACEBOOK = 'facebook'
}

export enum PhoneNumberAuthPurpose {
  SIGN_IN = 'signin',
  SIGN_UP = 'signup'
}

export type AuthMethod = SocialAuthMethod | 'email' | 'phone'

export type AsyncCreateProfileData = {
  firstName: string
  lastName: string
  school: {
    name: string
  }
  country: string
  grade: string
}

export type SignUpData = {
  email: string
  password: string
  profile: AsyncCreateProfileData
}

export interface PhoneNumberSignUpData {
  phoneNumber: string
  code: string
  profile: AsyncCreateProfileData
}

export interface SignUpViaSocialData {
  profile: AsyncCreateProfileData
  ssoProvider: string
  firebaseIdToken: string
}

export interface PromoteCandidateData {
  email: string
  password: string
}

export interface CandidateSignUpData {
  firstName: string
  birthYear: number
  countryCode: string
  // level: OnboardingEnglishLevel
}

export interface AuthResponse {
  token: string
  user: User
}

export interface SocialAuthResponse {
  token: string
  user: User
}

export interface UpdateUserScoreData {
  score: number
  scoreToAdd: number
  bookId?: string
}

export enum UserServiceActionTypes {
  SET_USER = 'user/load_user',
  SET_CANDIDATE = 'user/load_candidate_user',
  UPDATE_USER = 'user/update_user',
  UPDATE_USER_PROFILE = 'user/update_user_profile',
  SET_USER_NPS_MODAL_COMPLETED = 'user/set_user_nps_modal_completed',
  SET_USER_ONBOARDING_COMPLETED = 'user/set_user_onboarding_completed',
  SET_USER_PT_LEAD_MODAL_COMPLETED = 'user/set_user_pt_lead_modal_completed',
  SET_USER_NOTIFICATIONS_SETTINGS = 'user/set_user_notifications_settings',
  SET_USER_SOUND_SETTINGS = 'user/set_user_sound_settings',
  SET_NPS_MODAL_DISPLAYED = 'user/set_nps_modal_displayed',
  DISSMISS_RATE_US_POPUP = 'user/dismiss_rate_us_popup',
  SET_UPDATE_LIST = 'user/set_update_list',
  LOGOUT = 'user/logout'
}

export type LoadUserAction = {
  type: UserServiceActionTypes.SET_USER
  user: User
}

export type DismissRateUsPopupAction = {
  type: UserServiceActionTypes.DISSMISS_RATE_US_POPUP
}

export type SetUserOnboardingCompletedAction = {
  type: UserServiceActionTypes.SET_USER_ONBOARDING_COMPLETED
}

export type SetNpsModalDisplayedAction = {
  type: UserServiceActionTypes.SET_NPS_MODAL_DISPLAYED
  displayed: boolean
}

export type SetUserNpsModalCompletedAction = {
  type: UserServiceActionTypes.SET_USER_NPS_MODAL_COMPLETED
  completed: boolean
}

export type SetUserPtModalCompletedAction = {
  type: UserServiceActionTypes.SET_USER_PT_LEAD_MODAL_COMPLETED
  completed: boolean
}

export type SetCandidateUserAction = {
  type: UserServiceActionTypes.SET_CANDIDATE
  candidate: User | null
}

export type LogoutAction = {
  type: UserServiceActionTypes.LOGOUT
}

export type UpdateUserAction = {
  type: UserServiceActionTypes.UPDATE_USER
  data: Partial<User>
}

export type SetUserNotificationsSettingsAction = {
  type: UserServiceActionTypes.SET_USER_NOTIFICATIONS_SETTINGS
  notificationSettings: UserNotificationsSettings
}

export type SetUserSoundSettingsAction = {
  type: UserServiceActionTypes.SET_USER_SOUND_SETTINGS
  soundEffectsEnabled: boolean
}

export type CreateUserProfileAction = {
  type: UserServiceActionTypes.UPDATE_USER_PROFILE
  userProfile: UserProfile
}

export type UpdateUserProfileAction = {
  type: UserServiceActionTypes.UPDATE_USER_PROFILE
  userProfile: UserProfile
}

export type SetUpdateListAction = {
  type: UserServiceActionTypes.SET_UPDATE_LIST
  lists: UpdateLists
}

export type UserServiceActions =
  | LoadUserAction
  | DismissRateUsPopupAction
  | SetUserOnboardingCompletedAction
  | SetNpsModalDisplayedAction
  | SetUserNpsModalCompletedAction
  | SetCandidateUserAction
  | SetUserPtModalCompletedAction
  | LogoutAction
  | CreateUserProfileAction
  | UpdateUserProfileAction
  | SetUserNotificationsSettingsAction
  | SetUserSoundSettingsAction
  | UpdateUserAction
  | SetUpdateListAction

export type UserServiceState = {
  entity: User | null
  candidate: User | null
  updateLists: UpdateLists | null
  rateUsPopupDismissed: boolean
  npsModalDisplayed: boolean
}
